//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('payments', {
//        templateUrl: 'views/components/views/payments/payments.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'paymentsService', function (stateService, paymentsService) {
//            const vm = this;
            
//            vm.model = {
//                itemsListPayments: []
//            };

//            async function loadPayments() {
//                vm.model.itemsListPayments = await paymentsService.listPayments();
//            }
            
//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'payment':
//                        go({ payment_id: '' });
//                        break;
//                    default:
//                        break;
//                }
//            };
            
//            vm.$onInit = async function () {
//                loadPayments();
//            }
//        }]
//    });
//})();
